import { Component } from '@angular/core';

@Component({
    templateUrl: './my-profile-parent-page.component.html',
    styleUrls: ['./my-profile-parent-page.component.scss']
})
export class MyProfileParentPageComponent {}
